module.exports = "<img *ngIf=\"product\"  class=\"env-image canvas-img\" [style.z-index]=\"zIndex\" [style.width]=\"width\" [style.height]=\"height\" [style.margin-left]=\"marginLeft\" style=\"opacity: 0\" />\r\n<img class=\"hidden-img env-image\" [style.z-index]=\"zIndex\" [style.width]=\"width\" [style.height]=\"height\" [style.margin-left]=\"marginLeft\" style=\"opacity: 0\" [src]=\"productImageSrc\" />"


//////////////////
// WEBPACK FOOTER
// ./src/app/canvas/product-image.component.html
// module id = 547
// module chunks = 1